import { SEGMENT_NAME_MAX, SegmentSchema, type SegmentScope } from "#shared/segmentsTypes.ts";
import { oc } from "@orpc/contract";
import { z } from "zod";

const SegmentScopeSchema = z.enum(["mine", "shared-with-me"]) satisfies z.ZodType<SegmentScope>;

const ListSegmentsInputSchema = z.object({
    orgId: z.string(),
    scope: SegmentScopeSchema,
    continuationToken: z.string().optional(),
    pageSize: z.number().default(25),
    q: z.string().optional(),
    tags: z.array(z.string()).optional()
});

const ListSegmentsOutputSchema = z.object({
    items: z.array(SegmentSchema),
    continuationToken: z.string().optional(),
    totalCount: z.number()
});

const CountSegmentsInputSchema = z.object({
    orgId: z.string(),
    scope: SegmentScopeSchema,
    q: z.string().optional(),
    tags: z.array(z.string()).optional()
});

const CountSegmentsOutputSchema = z.object({
    totalCount: z.number()
});

const DeleteSegmentsInputSchema = z.union([z.object({ ids: z.array(z.string()) }), z.object({ q: z.string().optional(), excludedIds: z.array(z.string()) })]);

const ListSegmentTagsInputSchema = z.object({
    orgId: z.string()
});

const ListSegmentTagsOutputSchema = z.object({
    items: z.array(z.string())
});

const SegmentIdInputSchema = z.object({
    segmentId: z.string()
});

const RenameSegmentInputSchema = SegmentIdInputSchema.extend({
    name: z.string().trim().min(1).max(SEGMENT_NAME_MAX)
});

const segmentErrors = {
    NOT_FOUND: { message: "Segment not found", data: SegmentIdInputSchema }
} as const;

export const segmentsListContract = {
    listSegments: oc.route({ method: "GET", path: "/list-segments" }).input(ListSegmentsInputSchema).output(ListSegmentsOutputSchema),
    countSegments: oc.route({ method: "GET", path: "/count-segments" }).input(CountSegmentsInputSchema).output(CountSegmentsOutputSchema),
    listSegmentTags: oc.route({ method: "GET", path: "/list-segment-tags" }).input(ListSegmentTagsInputSchema).output(ListSegmentTagsOutputSchema),
    deleteSegments: oc.route({ method: "POST", path: "/delete-segments" }).input(DeleteSegmentsInputSchema).output(z.void()),
    renameSegment: oc.route({ method: "POST", path: "/rename-segment" }).errors(segmentErrors).input(RenameSegmentInputSchema).output(z.void())
};
